import BaseAPI from './base'

class PracticeSupportAPI extends BaseAPI {}

export default new PracticeSupportAPI('v1/practice-support', 'PracticeCourse')
